<template>
  <section id="user-all">
    <b-card>
      <b-card-body>
        <v-data-table
            :headers="headers"
            :items="desserts"
            :items-per-page="40"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn
                color="primary"
                @click="initialize"
            >
              Reset
            </v-btn>
          </template>
        </v-data-table>
      </b-card-body>
    </b-card>

  </section>

</template>
<script>
import {
  BCard, BCardBody, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import axios from 'axios'
import router from '@/router'
import Config from '../../../config'
import userService from "@/services/user.service";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
  },
  data() {
    return {
      desserts: [],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Family', value: 'family' },
        { text: 'Mobile', value: 'mobile' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
  },
  async created() {
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    initialize() {
      userService.getAll().then(
          res => {
            if (res.status === 'success') {
              if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
                for (let i = 0; i <= res.result.data.length - 1; i++) {
                  this.desserts.push(res.result.data[i])
                }
              }
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
      )
    },
    addClick() {
      router.push({ path: '/office/add' })
    },
    deleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('Are you sure you want to delete this item?')) {
        userService.delete({
          // eslint-disable-next-line no-underscore-dangle
          userId: this.desserts[index]._id,
          companyId: localStorage.getItem('companySelected'),
        }).then(
            res => {
              if (res.status !== 'success') {
                alert(JSON.stringify((res)))
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'register error',
                    text: res.result,
                    icon: 'XIcon',
                    variant: 'danger',
                  },
                })
              } else {
                this.desserts.splice(index, 1)
              }
            },
            error => {
              this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: this.message,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            },
        )
      } else {
        index = ''
      }
      // Todo: Make this delete item from store
      // eslint-disable-next-line no-underscore-dangle
    },
  },
}
</script>
<style>
#user-all table thead tr {
  background: #f4f4f2;
}
#user-all table thead tr th{
  font-size: 1rem;
  color: azure;
  font-size: 0.9rem;
  color: #2b2b2b;
  font-weight: bold;
}
</style>
